var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4C4.5 3.58579 4.83579 3.25 5.25 3.25L18.75 3.25C19.1642 3.25 19.5 3.58579 19.5 4C19.5 4.41421 19.1642 4.75 18.75 4.75L5.25 4.75C4.83579 4.75 4.5 4.41421 4.5 4ZM2.25 9.33333C2.25 8.91912 2.58579 8.58333 3 8.58333L21 8.58333C21.4142 8.58333 21.75 8.91912 21.75 9.33333C21.75 9.74755 21.4142 10.0833 21 10.0833L3 10.0833C2.58579 10.0833 2.25 9.74755 2.25 9.33333ZM4.5 14.6667C4.5 14.2525 4.83579 13.9167 5.25 13.9167H18.75C19.1642 13.9167 19.5 14.2525 19.5 14.6667C19.5 15.0809 19.1642 15.4167 18.75 15.4167H5.25C4.83579 15.4167 4.5 15.0809 4.5 14.6667ZM2.25 20C2.25 19.5858 2.58579 19.25 3 19.25H21C21.4142 19.25 21.75 19.5858 21.75 20C21.75 20.4142 21.4142 20.75 21 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextCenter);
export default __webpack_public_path__ + "static/media/Text-center.347742a97bd4e3f2ca3fc6ea8d1e0ecb.svg";
export { ForwardRef as ReactComponent };